import { type ComponentType, type LazyExoticComponent, lazy } from "react"

import { retryImport } from "./retryImport"

/**
 * Wraps `React.lazy` for modules that use named exports instead of a default
 * export. The loader returns the module record; `name` selects the exported
 * component by key.
 */
export function lazyNamed<T extends ComponentType<any>>(
  // `ComponentType<any>` (rather than `ComponentType<unknown>`) is intentional:
  // callers pass in a specific component type `T` with its own props, and
  // `ComponentType<unknown>` rejects any component that declares concrete
  // prop types. This generic wrapper needs the bivariant behavior of `any`
  // on the prop parameter so arbitrary components can satisfy it.
  loader: () => Promise<Record<string, unknown>>,
  name: string,
): LazyExoticComponent<T> {
  return lazy(async () => {
    const mod = await retryImport(loader)
    return { default: mod[name] as T }
  })
}
